export default [
    {
        title: '主材招采',
        path: '/materialPriceInquiry/main',
        name: 'materialPriceInquiry',
        meta: {
            key: 'materialPriceInquiry'
        },
        permission: 'materialPriceInquiry',
        menu: true,
        children: [
            {
                title: '主单管理',
                path: '/materialPriceInquiry/main',
                name: 'materialPriceInquiryMain',
                component: () => import('@/views/materialPriceInquiry/main'),
                meta: {
                    key: 'materialPriceInquiryMain',
                    open: 'materialPriceInquiry'
                },
                permission: 'materialPriceInquiryMain'
            },
            {
                title: '子单管理',
                path: '/materialPriceInquiry/item',
                name: 'materialPriceInquiryItem',
                component: () => import('@/views/materialPriceInquiry/item'),
                meta: {
                    key: 'materialPriceInquiryItem',
                    open: 'materialPriceInquiry'
                },
                permission: 'materialPriceInquiryItem'
            },
            {
                title: '报价单管理',
                path: '/materialPriceInquiry/price',
                name: 'materialPriceInquiryPrice',
                component: () => import('@/views/materialPriceInquiry/price'),
                meta: {
                    key: 'materialPriceInquiryPrice',
                    open: 'materialPriceInquiry'
                },
                permission: 'materialPriceInquiryPrice'
            }
        ]
    },
    {
        title: '主单详情',
        path: '/materialPriceInquiry/main/info',
        name: 'materialPriceInquiryMainInfo',
        component: () => import('@/views/materialPriceInquiry/mainInfo'),
        meta: {
            key: 'materialPriceInquiryMain',
            open: 'materialPriceInquiry'
        },
        permission: false
    },
    {
        title: '子单详情',
        path: '/materialPriceInquiry/item/info',
        name: 'materialPriceInquiryItemInfo',
        component: () => import('@/views/materialPriceInquiry/itemInfo'),
        meta: {
            key: 'materialPriceInquiryItem',
            open: 'materialPriceInquiry'
        },
        permission: false
    },
    {
        title: '报价单详情',
        path: '/materialPriceInquiry/price/info',
        name: 'materialPriceInquiryPriceInfo',
        component: () => import('@/views/materialPriceInquiry/priceInfo'),
        meta: {
            key: 'materialPriceInquiryPrice',
            open: 'materialPriceInquiry'
        },
        permission: false
    }
];
